import React from 'react';
import { motion } from 'framer-motion';
import { DocumentPen, PhoneSignal, SteeringWheel } from './Icons';
interface HowItWorksProps {
  lang: 'en' | 'es';
}
export const HowItWorks: React.FC<HowItWorksProps> = ({
  lang
}) => {
  const content = {
    en: {
      title: 'How It Works',
      steps: [{
        icon: DocumentPen,
        title: 'Fill the Form',
        desc: "Tell Simon what you're looking for"
      }, {
        icon: PhoneSignal,
        title: 'Simon Contacts You',
        desc: 'Same-day personal response guaranteed'
      }, {
        icon: SteeringWheel,
        title: 'Drive Your Car',
        desc: 'Get the best deal and hit the road'
      }]
    },
    es: {
      title: 'Cómo Funciona',
      steps: [{
        icon: DocumentPen,
        title: 'Llena el Formulario',
        desc: 'Dile a Simon lo que buscas'
      }, {
        icon: PhoneSignal,
        title: 'Simon te Contacta',
        desc: 'Respuesta personal el mismo día'
      }, {
        icon: SteeringWheel,
        title: 'Maneja tu Auto',
        desc: 'Obtén el mejor trato y sal a rodar'
      }]
    }
  };
  const t = content[lang];
  return <section className="py-24 px-6 bg-background border-t border-border" data-id="element-37">
      <div className="max-w-5xl mx-auto" data-id="element-38">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center mb-20" data-id="element-39">
          {t.title}
        </motion.h2>

        <div className="relative" data-id="element-40">
          {/* Dotted Line connecting steps (Desktop) */}
          <div className="hidden md:block absolute top-10 left-[15%] right-[15%] h-[2px] border-t-2 border-dashed border-border z-0" data-id="element-41" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-6 relative z-10" data-id="element-42">
            {t.steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-43">
                <div className="w-20 h-20 rounded-full bg-card border-2 border-border flex items-center justify-center mb-6 relative" data-id="element-44">
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-sm font-bold border-4 border-background" data-id="element-45">
                    {index + 1}
                  </div>
                  <step.icon className="text-white" size={32} data-id="element-46" />
                </div>
                <h3 className="text-xl font-semibold mb-3" data-id="element-47">{step.title}</h3>
                <p className="text-[#aaaaaa] max-w-[250px]" data-id="element-48">{step.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};